var _circle, _circle2, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgExpired = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FDAD38",
    fillOpacity: 0.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 25,
    fill: "#FDAD38"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6621 34.4746H27.373L26.4766 17.3008H32.5586L31.6621 34.4746ZM26.4062 40.4863C26.4062 39.502 26.6699 38.7578 27.1973 38.2539C27.7246 37.75 28.4922 37.498 29.5 37.498C30.4727 37.498 31.2227 37.7559 31.75 38.2715C32.2891 38.7871 32.5586 39.5254 32.5586 40.4863C32.5586 41.4121 32.2891 42.1445 31.75 42.6836C31.2109 43.2109 30.4609 43.4746 29.5 43.4746C28.5156 43.4746 27.7539 43.2168 27.2148 42.7012C26.6758 42.1738 26.4062 41.4355 26.4062 40.4863Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExpired, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/expired.da643b33.svg";
export { ForwardRef as ReactComponent };